import { db } from "../firebase";
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, where } from "firebase/firestore";

export async function addMeal(meal, householdId){

  await addDoc(
    collection(db,"meals"),
    { ...meal, householdId }
  );

}

export async function getMeals(householdId){

  const q = query(
    collection(db,"meals"),
    where("householdId","==",householdId)
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map(d=>({
    id:d.id,
    ...d.data()
  }));

}

export async function updateMeal(id, meal){

  await updateDoc(doc(db,"meals",id), meal);

}

export async function deleteMeal(id){

  await deleteDoc(doc(db,"meals",id));

}
